// Mantine
import { Button, Modal } from '@mantine/core'
import { useDisclosure } from '@mantine/hooks'

// Icons
import { IconPrinter, IconChecklist } from '@tabler/icons-react'

// UI
import Banner from '../ui/Banner'

// Hook
import useUserLocation from '@/hooks/useUserLocation'

export default function ShipmentPrintModal({
    shipment,
    printAndMarkAsFullfilled,
    loading,
}) {
    // Disclosure of modal
    const [opened, handlers] = useDisclosure(false)

    const { userPrinter } = useUserLocation()
    const hasPrinter = Boolean(userPrinter)

    return (
        <>
            <Modal
                opened={opened}
                onClose={handlers.close}
                title="Confirmer les éléments suivants"
            >
                <div className="flex flex-col gap-3">
                    <div className="flex flex-col">
                        <span className="text-sm font-medium">
                            Lieu de préparation
                        </span>
                        <span>{shipment.from_location.name}</span>
                    </div>

                    <div className="flex flex-col">
                        <span className="text-sm font-medium">
                            Nombre de colis
                        </span>
                        <span>{shipment.number_of_packages} carton(s)</span>
                    </div>

                    <div className="flex flex-col">
                        <span className="text-sm font-medium">Suivi DHL</span>

                        <span>{shipment.tracking_code} - Généré par le BO</span>
                    </div>

                    <div className="flex flex-col">
                        <span className="text-sm font-medium">Imprimante</span>
                        <span>{userPrinter?.name ?? "Pas d'imprimante"}</span>
                    </div>

                    {!hasPrinter && (
                        <Banner
                            compact
                            type="warning"
                            title="Aucune imprimante n'est configurée"
                        >
                            Veuillez configurer une imprimante dans vos
                            paramètres.
                        </Banner>
                    )}

                    {hasPrinter && (
                        <>
                            <Button
                                loading={loading}
                                leftSection={
                                    <div className="flex gap-1">
                                        <IconPrinter size={18} />
                                        {' + '}
                                        <IconChecklist size={18} />
                                    </div>
                                }
                                variant="primary"
                                onClick={printAndMarkAsFullfilled}
                            >
                                Imprimer et marquer comme expedié
                            </Button>

                            <span className="text-xs text-center text-gray-600">
                                Cette demande de préparation sera marquée comme
                                expédiée
                            </span>
                        </>
                    )}
                </div>
            </Modal>

            <div>
                <Button
                    variant="primary"
                    className="mx-auto"
                    leftSection={
                        <div className="flex gap-1">
                            <IconPrinter size={18} />
                            {' + '}
                            <IconChecklist size={18} />
                        </div>
                    }
                    onClick={handlers.open}
                >
                    Imprimer et marquer comme expédié
                </Button>
            </div>
        </>
    )
}
